// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2388":"0b22195dc5f41a0e","4171":"0b22195dc5f41a0e","9092":"0b22195dc5f41a0e"}[chunkId] + ".css";
};